import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'highlightKey'
})
export class HighlightKeyPipe implements PipeTransform {

transform(lines: string[], keyword: string): string[] {
  if (!keyword?.trim()) return lines;
  const keywords = keyword.toLowerCase().split(',').map(k => k.trim()).filter(Boolean);
  return lines.filter(line =>
    keywords.some(k => line.toLowerCase().includes(k))
  );
}

}
